<template>
   <svg width="18" height="18" viewBox="0 0 18 18" xmlns="http://www.w3.org/2000/svg">
     <path d="M17.69 16.23l-5.43-5.43c.84-1.1 1.3-2.5 1.3-4.02A6.77 6.77 0 006.79 0a6.77 6.77 0 100 13.56c1.52 0 2.87-.46 4.02-1.3l5.43 5.43c.2.2.47.31.73.31s.52-.1.73-.31c.41-.42.41-1.05 0-1.46zm-10.9-4.75c-2.62 0-4.7-2.09-4.7-4.7 0-2.6 2.08-4.7 4.7-4.7 2.6 0 4.69 2.1 4.69 4.7 0 2.61-2.09 4.7-4.7 4.7z" />
   </svg>
</template>

<script>
export default {
   name: 'SearchIcon'
}
</script>